"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.templates = void 0;
exports.templates = [
    "default",
    "decision-tree",
    "process-lanes",
    "blueprint",
    "ink-mindmap",
    "constellation",
    "org-chart",
    "sitemap",
    "timeline",
    "storyline",
];
